import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['display', 'showBtn', 'hideBtn'];

  toggle() {
    this.toggleDisplay(this.displayTarget);
    this.toggleDisplay(this.showBtnTarget);
    this.toggleDisplay(this.hideBtnTarget);
  }
  toggleDisplay(target) {
    if (target.classList.contains('hidden')) {
      target.classList.remove('hidden');
    } else {
      target.classList.add('hidden');
    }
  }
}
